import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Coupons from "./components/coupons/Coupons";
import AddCoupon from "./components/coupons/AddCoupon";
import EditCoupon from "./components/coupons/EditCoupon";
import Couponredemtions from "./components/coupons/couponredemtions/Couponredemtions";
import AddCouponRedemtion from "./components/coupons/couponredemtions/AddCouponRedemtion";
import EditCouponRedemtion from "./components/coupons/couponredemtions/EditCouponRedemtion";
import Shops from "./components/shops/Shops";
import AddShop from "./components/shops/AddShop";
import EditShop from "./components/shops/EditShop";
import Events from "./components/events/Events";
import AddEvent from "./components/events/AddEvent";
import EditEvent from "./components/events/EditEvent";
import Eventbookings from "./components/events/eventbooking/Eventbookings";
import AddEventbooking from "./components/events/eventbooking/AddEventbooking";
import EditEventbooking from "./components/events/eventbooking/EditEventbooking";
import Courses from "./components/courses/Courses";
import AddCourse from "./components/courses/AddCourse";
import EditCourse from "./components/courses/EditCourse";
import Coursebookings from "./components/courses/coursebooking/Coursebookings";
import AddCoursebooking from "./components/courses/coursebooking/AddCoursebooking";
import EditCoursebooking from "./components/courses/coursebooking/EditCoursebooking";
import Users from "./components/users/Users";
import AddUser from "./components/users/AddUser";
import EditUser from "./components/users/EditUser";
import EditCustomerPassword from "./components/users/EditCustomerPassword";
import Bookings from "./components/bookings/Bookings"
import Categories from "./components/category/Categories"
import EditCategory from "./components/category/EditCategory";
import AddCategory from "./components/category/AddCategory";


import TopHeader from "./components/include/TopHeader";
import Sidebar from "./components/include/Sidebar";
//import Footer from "./components/include/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

const Layout = ({ children }) => {
  const { isLoggedIn } = useAuth();
  return (
    <>
      {isLoggedIn && <TopHeader />}
      {isLoggedIn && <Sidebar />}
      {children}
    </>
  );
};


function AppRoutes() {
  const { isLoggedIn } = useAuth();

  return (
    <Routes>
      <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupons"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <Coupons />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupon/add"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <AddCoupon />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coupon/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <EditCoupon />
          </ProtectedRoute>
        }
      />

      <Route
        path="/couponredemtions/:crid"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <Couponredemtions />
          </ProtectedRoute>
        }
      />

      <Route
        path="/couponredemtion/add/:crid"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <AddCouponRedemtion />
          </ProtectedRoute>
        }
      />

      <Route
        path="/couponredemtion/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <EditCouponRedemtion />
          </ProtectedRoute>
        }
      />

      <Route
        path="/shops"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <Shops />
          </ProtectedRoute>
        }
      />

      <Route
        path="/shop/add"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <AddShop />
          </ProtectedRoute>
        }
      />

      <Route
        path="/shop/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "business"]}>
            <EditShop />
          </ProtectedRoute>
        }
      />


      <Route
        path="/events"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <Events />
          </ProtectedRoute>
        }
      />

      <Route
        path="/event/add"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <AddEvent />
          </ProtectedRoute>
        }
      />

      <Route
        path="/event/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <EditEvent />
          </ProtectedRoute>
        }
      />

      <Route
        path="/eventbookings/:eid"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <Eventbookings />
          </ProtectedRoute>
        }
      />

      <Route
        path="/eventbooking/add/:eid"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <AddEventbooking />
          </ProtectedRoute>
        }
      />

      <Route
        path="/eventbooking/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "event"]}>
            <EditEventbooking />
          </ProtectedRoute>
        }
      />

      <Route
        path="/courses"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <Courses />
          </ProtectedRoute>
        }
      />

      <Route
        path="/course/add"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <AddCourse />
          </ProtectedRoute>
        }
      />

      <Route
        path="/course/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <EditCourse />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coursebookings/:cid"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <Coursebookings />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coursebooking/add/:cid"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <AddCoursebooking />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coursebooking/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin", "course"]}>
            <EditCoursebooking />
          </ProtectedRoute>
        }
      />


      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Users />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user/add"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddUser />
          </ProtectedRoute>
        }
      />

      <Route
        path="/user/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EditUser />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customer/updatepass/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EditCustomerPassword />
          </ProtectedRoute>
        }
      />


      <Route
        path="/bookings"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Bookings />
          </ProtectedRoute>
        }
      />

      <Route
        path="/categories"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Categories />
          </ProtectedRoute>
        }
      />

      <Route
        path="/category/add"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AddCategory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/category/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EditCategory />
          </ProtectedRoute>
        }
      />

    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <AppRoutes />
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
